import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../App.css";

import { Divider, IconButton, Menu, MenuItem } from "@mui/material";
import ListSubheader from '@mui/material/ListSubheader';
import LanguageIcon from '@mui/icons-material/Language';

const ChangeLang = () => {
  const [anchorElLang, setAnchorElLang] = useState(null);

  const langs = [
    {code: "en", label: "English"},
    {code: "hi", label: "हिन्दी"}
  ]

  const { i18n } = useTranslation();

  const handleOpenLangMenu = (event) => {
    setAnchorElLang(event.currentTarget);
  };

  const handleCloseLangMenu = () => {
    setAnchorElLang(null);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setAnchorElLang(null);
  };

  return (
    <div className="langMenuDiv">
      <IconButton
        size="medium"
        // edge="start"
        color="inherit"
        aria-label="lang-menu"
        onClick={handleOpenLangMenu}
        sx={{padding: 0}}
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        id="lang-menu-appbar"
        className="langMenu"
        anchorEl={anchorElLang}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElLang)}
        onClose={handleCloseLangMenu}
      >
        <ListSubheader>Change Language</ListSubheader>
        <Divider/>
        {langs.map(lang => (
          <MenuItem key={lang.code} onClick={() => changeLanguage(lang.code)} selected={i18n.language === lang.code}>
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ChangeLang;
